import newSagas from "./new";
import updateSagas from "./update";

export const canvasSagas = [
	...newSagas,
	...updateSagas
];

export default canvasSagas;
